import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {Tag, TAG_SIZES, TAG_USAGES} from '@adv-mt/ui/tag'
import {Body2} from '@adv-mt/ui/typography'

import {useContactCardInput, useContactCardState, useContactSellerV2Config} from '../context/ContactSellerV2Context.js'
import {useFormContext} from '../form/formContexts.js'
import {V2_FIELDS} from '../schema/contactSchema.js'
import {useContactFormContext} from './ContactFormContext.js'
import {BASE_CLASS} from './FormFields.js'

const FINANCING_INTENTION_ID = 'FINANCING'
const INTENTIONS_TITLE_ID = 'contact-form-v2-buyer-intentions-title'

const hasBuyerIntentions = ({
  buyerIntentions = [],
  isLeadEnrichmentEnabled = false,
  isVOorVNorKM0 = false,
  isPrivateSeller = false
} = {}) => isLeadEnrichmentEnabled && isVOorVNorKM0 && !isPrivateSeller && buyerIntentions.length > 0

const BuyerIntentions = () => {
  const {i18n} = useContext(Context)
  const form = useFormContext()
  const {isPrivateSeller = false} = useContactSellerV2Config()
  const {buyerIntentions = [], isLeadEnrichmentEnabled = false, isVOorVNorKM0 = false} = useContactCardInput()
  const {setBuyerIntentionsSelection: onBuyerIntentionsChange} = useContactCardState()
  const {persistBuyerIntentions} = useContactFormContext()
  const isEnabled = Boolean(isLeadEnrichmentEnabled && isVOorVNorKM0 && !isPrivateSeller)

  const notify = selection =>
    onBuyerIntentionsChange?.({
      selectedBuyerIntentions: selection,
      hasFinancingIntention: selection.includes(FINANCING_INTENTION_ID)
    })

  if (!isEnabled || !buyerIntentions.length) {
    return null
  }

  return (
    <form.Field name={V2_FIELDS.BUYER_INTENTIONS}>
      {field => {
        const selected = field.state.value ?? []

        const toggle = id => {
          const next = selected.includes(id) ? selected.filter(current => current !== id) : [...selected, id]

          field.handleChange(next)
          persistBuyerIntentions?.(next)
          notify(next)
        }

        return (
          <div className={`${BASE_CLASS}-intentionsGroup`} role="group" aria-labelledby={INTENTIONS_TITLE_ID}>
            <Body2 as="p" id={INTENTIONS_TITLE_ID} className={`${BASE_CLASS}-intentionsTitle`}>
              {i18n.t('CONTACT_SELLER_V2.FORM.BUYER_INTENTIONS_TITLE')}
            </Body2>
            <div className={`${BASE_CLASS}-intentions`}>
              {buyerIntentions.map(({id, shortLabel}) => (
                <Tag
                  key={id}
                  usage={TAG_USAGES.FILTER}
                  size={TAG_SIZES.MEDIUM}
                  selected={selected.includes(id)}
                  onClick={() => toggle(id)}
                >
                  {shortLabel}
                </Tag>
              ))}
            </div>
          </div>
        )
      }}
    </form.Field>
  )
}

BuyerIntentions.displayName = 'ContactFormV2BuyerIntentions'

BuyerIntentions.propTypes = {}

export {FINANCING_INTENTION_ID, hasBuyerIntentions}

export default BuyerIntentions
